import * as Yup from 'yup'
import moment from 'moment'
import momentTz from 'moment-timezone'
import config from 'configuration'

export const classNames = (...args) => {
  const classes = []

  args.forEach((arg) => {
    if (typeof arg === 'string') {
      classes.push(arg)
    } else if (Array.isArray(arg)) {
      classes.push(classNames(...arg))
    } else if (typeof arg === 'object') {
      classes.push(classNames(...Object.keys(arg).filter((k) => arg[k])))
    }
  })

  return classes.join(' ')
}

export const hasD2CExtension = () => {
  return sendMessageToD2CExtension({ message: 'handshake' })
}

export const sendMessageToD2CExtension = (payload) => {
  // if you want to work with local extension –
  // check 'configuration' file, `dev` object –
  // change extension id to match your local
  return new Promise((resolve) => {
    if (!window.chrome?.runtime) {
      resolve(false)
      return
    }

    window.chrome.runtime.sendMessage(
      config.d2cExtensionID,
      payload,
      (reply) => {
        resolve(reply)
      }
    )
  })
}

export const redirect = (basePath, subPage) => {
  window.location = `${basePath}${subPage}`
}

export const resetDateTime = (date) =>
  date.set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  })

export const toCalendarDate = (instant) => moment(instant).format('YYYY-MM-DD')

export const easternToday = () =>
  moment(momentTz.tz('America/New_York').format('YYYY-MM-DD'))

export const AggregationTypes = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
}

export const getAggregation = (startDate, endDate) => {
  const days = endDate.diff(startDate, 'days')

  switch (true) {
    case days <= 31:
      return AggregationTypes.DAY
    case days > 31 && days <= 92:
      return AggregationTypes.WEEK
    case days > 92 && days <= 365:
      return AggregationTypes.MONTH
    case days > 365:
      return AggregationTypes.YEAR
    default:
      return AggregationTypes.MONTH
  }
}

export const pad = (num, size = 9) => {
  const s = `000000000${num}`

  return s.substr(s.length - size)
}

export const getConditionalValidation = (parent, conditionValue) =>
  Yup.string().when(parent, {
    is: conditionValue,
    then: Yup.string().required('Required'),
    otherwise: Yup.string(),
  })
